import React from "react";

export const DeleteIcon = React.memo(() => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.14993 4.6H3.44993M3.44993 4.6H13.8499M3.44993 4.6V13.7C3.44993 14.0448 3.5869 14.3754 3.83069 14.6192C4.07449 14.863 4.40515 15 4.74993 15H11.2499C11.5947 15 11.9254 14.863 12.1692 14.6192C12.413 14.3754 12.5499 14.0448 12.5499 13.7V4.6M5.39993 4.6V3.3C5.39993 2.95522 5.5369 2.62456 5.78069 2.38076C6.02449 2.13696 6.35515 2 6.69993 2H9.29993C9.64472 2 9.97537 2.13696 10.2192 2.38076C10.463 2.62456 10.5999 2.95522 10.5999 3.3V4.6M6.69993 7.85V11.75M9.29993 7.85V11.75" stroke="#F37174" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
});